import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";

declare var ko: any;

export class fieldList_template extends vnTemplate {


    //As VM
    protected filter: filterSimple_template;
    protected resultInfos: resultsInfo_template;
    protected pagination: pagination_template;

    protected initPartial() {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template('resultInfo', this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
    }

    public getViewModelForRequest(): any {
        return {
            orderBy: this.getTemplateViewModel().orderBy,
            orderByDirection: this.getTemplateViewModel().orderByDirection,
            orderByAndDirection: this.getTemplateViewModel().orderByAndDirection,
            pagination: this.getTemplateViewModel().pagination,
            filters : {
                keywords : this.getTemplateViewModel().filter.filterKeyword
            },
        }
    }

    protected buildViewModel(): any {
        let self = this
        return {
            fields: ko.observableArray([]),
            orderBy: ko.observable("idField"),
            orderByDirection: ko.observable("DESC"),
            orderByAndDirection: ko.observable("idField_DESC"),
            idFieldToDelete: ko.observable(null),
            onClickReorder: (value, data, event) => {
                self.onClickReorder(value, data, event);
            },
            viewField: (data, event) => {
                self.viewField(data.id, event);
            },
            onClickAdd: (data, event) => {
                self.onClickAdd()
            },
            onClickShowPopUp : (data, event) =>{
                self.onClickShowPopUp(data)
            },
            onClickHidePopUp : (data, event)=>{
                self.onClickHidePopUp()
            },
            onClickDelete : (data, event)=>{
                self.onClickDelete()
            }
        }
    }

    protected getTemplateHtml(): string {
        return (`
        <div class="list-header w-justify">
            <div class="w-left" >
                    <button data-bind="event: {click: onClickAdd}" class="btn secondary icon i-add" type="button">Create Field</button>    
            </div>
            <div class="w-center">
                <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                    <div class="w-search-feild icon i-search2">
                        <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                        <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                        <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                        <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                    </div>
                </div>
            </div>
            <div class="w-right">
                ` + this.pagination.getHtmlBuild() + `
            </div>
        </div>
        
        <div class="w-list-results" id="list-results">
            <table class="list-results">
                ` + this.resultInfos.getHtmlBuild() + `
                    <thead>
                        <tr>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idField') }, css: { 'list-sort-desc': orderByAndDirection()=='idField_DESC', 'list-sort-asc': orderByAndDirection()=='idField_ASC' }">ESP ID</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'label') }, css: { 'list-sort-desc': orderByAndDirection()=='label_DESC', 'list-sort-asc': orderByAndDirection()=='label_ASC' }">Label</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'type') }, css: { 'list-sort-desc': orderByAndDirection()=='type_DESC', 'list-sort-asc': orderByAndDirection()=='type_ASC' }">Type</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateUpdated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateUpdated_DESC', 'list-sort-asc': orderByAndDirection()=='dateUpdated_ASC' }">Date Updated</span></th>
                            <!-- <th class="align-right"><span>Delete</span></th> -->
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: fields">
                        <tr class="cursor" data-bind="event: { click: $parent.viewField } ">
                            <td data-bind="event: { click: $parent.viewField }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: idField"></span></a></td>
                            <td data-bind="event: { click: $parent.viewField }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: label"></span></a></td>       
                            <td data-bind="event: { click: $parent.viewField }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: type"></span></a></td>
                            <td data-bind="event: { click: $parent.viewField }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateCreated"></span></a></td>
                            <td data-bind="event: { click: $parent.viewField }"><a class="right-click" data-bind="attr: {href: emakiView}"><span data-bind="text: dateUpdated"></span></a></td>
                            <!-- <td class="align-right"><button type="button" data-bind="event: { click: $parent.onClickShowPopUp }, clickBubble: false" class="btn border only-icon highlight icon i-delete"></button></td> -->
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div id="delete-dialog" class="w-lightbox light-theme">
                <div class="lightbox-content">
                        
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Deleting field</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp }" class="close-button icon i-close-2"></button>
                        </div>
                   
                        <div class="form-body">
                            <div class="form-group">
                                <p class="form-text">This action is irreversible</p>
                                <p class="form-text">Are you sure you want to delete this field?</p>
                            </div>
                         </div>
                
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
        `);
    }

    protected getTemplateName(): string {
        return "fieldList_template";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected getMainElementType(): string {
        return "div";
    }

    public setResultInfo(nbResults, nbPages, execTime) {

        this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    protected viewField(data, event): any {
        this.caller.viewField(data)
    }

    protected onClickReorder(value, data, event): any {

        data.orderBy(value);
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.fieldsListReorder();
    }

    onClickAdd(): any {
        this.caller.addField()
    }

    onClickDelete() {
        let field_id = this.getTemplateViewModel().idFieldToDelete();
        this.toggleDeleteDialogVisibility();
        this.caller.deleteField(field_id);
    }

    onClickHidePopUp(): any {
        this.getTemplateViewModel().idFieldToDelete(null);
        this.toggleDeleteDialogVisibility()
    }
    onClickShowPopUp(data): any {

        this.getTemplateViewModel().idFieldToDelete(data);
        this.toggleDeleteDialogVisibility()
    }

    //Action on view model
    public setFields(fields, brandId) {
        fields.forEach((f) => f['emakiView'] = '/brand/' + brandId + '/newsletter/fields/view/' + f.id + '/');
        this.getTemplateViewModel().fields(fields)
    }

    public toggleDeleteDialogVisibility() {

        document.getElementById('delete-dialog').classList.toggle('is-visible');
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/fieldList_template.ts